"use strict";

const PointVisibility = {
  init() {
    let startPos = 0;
    let winScrollTop = 0;
    const holdPointBox = document.querySelector(".js_hold_pointBox");

    if (!holdPointBox) return;

    const handleScroll = () => {
      winScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (winScrollTop >= startPos && winScrollTop > 100) {
        // 下にスクロールしたとき
        holdPointBox.classList.add("is_hide");
      } else {
        // 上にスクロールしたとき
        holdPointBox.classList.remove("is_hide");
      }

      // ページ下部に到達したときは強制表示
      if (winScrollTop + window.innerHeight >= document.documentElement.scrollHeight - 150) {
        holdPointBox.classList.remove("is_hide");
      }

      startPos = winScrollTop;
    };

    window.addEventListener("scroll", handleScroll);
  }
};

/**
 * ページロード後にグローバル定数にPointVisibilityを追加する
 */
document.addEventListener("DOMContentLoaded", () => {
  Object.defineProperty(globalThis, "PointVisibility", {
    value: PointVisibility,
    writable: false,
  });
  PointVisibility.init();
});
